import { callApiWithAuthorization } from "../CallApi";

export const getProjectRoles = async (projectId) => {
    try {
        const request = await callApiWithAuthorization(`/api/v0/roles/${projectId}`)
        const result = await request.json()
        return result
    } catch (e) {
        return e
    }
}

export const updateRole = async (id, properties) => {
    try {
        const request = await callApiWithAuthorization(`/api/v0/role/${id}`, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(properties)
        })
        const result = await request.json()
        return result
    } catch (e) {
        return e
    }
}

export const createRole = async (projectId, properties) => {
    try {
        const request = await callApiWithAuthorization(`/api/v0/role/${projectId}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(properties)
        })
        const result = await request.json()
        return result
    } catch (e) {
        return e
    }
}